(() => {
    const init = () => {
      const dialog = document.getElementById('BangeMarketDialog');
      const trigger = document.querySelector('.bange-market-trigger');
      if (!dialog || !trigger || trigger.dataset.ready) return;
      trigger.dataset.ready = 'true';
      let previousOverflow = '';
      trigger.addEventListener('click', () => {
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
      });
      dialog.querySelector('.bange-market-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
